import api from '../..'
import { IFolderModel } from 'models/folder.model'

const createFolder = (data: IFolderModel) => {
  const folder = { folder: data }
  return api.post('/administration/folders', folder)
}

export default createFolder
